import { defaultHospitalData } from '../../../../backend/config/classifiers/defaults/DefaultHospitalData';
import { hospitalSchema } from '../../../../backend/config/classifiers/types';
import { allowManageCredentialingClassifiers, allowManageHospitalsClassifier } from '../../../../backend/features/permissions';
import { AuthError } from '@juvare/platform-app/App';
import { defineClassifierEntity, transformClassifierColumns } from '@juvare/platform-sdk-react/backend/features/classifiers';
import { classifierColumns } from '@juvare/platform-sdk-react/backend/features/classifiers/shared';
import { defineColumns } from '@juvare/platform-shared/features/storage';
export const hospitalEntityName = 'hospital';
const hospitalColumns = defineColumns(Object.assign(Object.assign({}, classifierColumns), { search: {
        type: 'full-text-search-required',
        language: 'english',
    } }));
export function defineHospitalClassifier() {
    return defineClassifierEntity({
        entity: {
            version: 3,
            columns: hospitalColumns,
            onMigrate: (params) => params.oldData,
            onTransformColumns: (context, params) => {
                return Object.assign(Object.assign({}, transformClassifierColumns(params)), { search: [
                        params.data.name,
                        params.data.status,
                        params.data.addressLine1,
                        params.data.addressLine2,
                        params.data.category,
                        params.data.city,
                        params.data.state,
                        params.data.zip,
                        params.data.contactNumber,
                        params.data.emergencyContactNumber,
                    ].join(' ') });
            },
            onAnonymousAuthList: (appState, response) => response,
            onAuthPost: (appState, userState) => {
                if (!allowManageCredentialingClassifiers(userState) && !allowManageHospitalsClassifier(userState)) {
                    throw new AuthError('Unauthorized');
                }
            },
        },
        defaultData: defaultHospitalData,
        publicData: true,
    }, hospitalSchema);
}
